import { useTranslation } from 'react-i18next'
import { Button } from 'ui/button'
import {
  Drawer,
  DrawerClose,
  DrawerContent,
  DrawerDescription,
  DrawerFooter,
  DrawerHeader,
  DrawerTitle,
} from 'ui/drawer'
import { useRegisterSW } from 'virtual:pwa-register/react'

export const UpdatePrompt = () => {
  const { t } = useTranslation()

  const {
    updateServiceWorker,
    needRefresh: [needRefresh, setNeedRefresh],
  } = useRegisterSW()

  if (!needRefresh) return null

  return (
    <Drawer
      onOpenChange={nextOpen => {
        if (!nextOpen) setNeedRefresh(false)
      }}
      open
    >
      <DrawerContent>
        <div className="mx-auto w-full max-w-sm">
          <DrawerHeader>
            <DrawerTitle>{t('Update available')}</DrawerTitle>
            <DrawerDescription>{t('A new version is ready Your cards and progress are safe')}</DrawerDescription>
          </DrawerHeader>
          <DrawerFooter className="p-4">
            <Button
              onClick={() => {
                setNeedRefresh(false)
                void updateServiceWorker(true)
              }}
            >
              {t('Update now')}
            </Button>
            <DrawerClose onClick={() => setNeedRefresh(false)} render={<Button variant="outline" />}>
              {t('Not now')}
            </DrawerClose>
          </DrawerFooter>
        </div>
      </DrawerContent>
    </Drawer>
  )
}
